import {useFile} from '@hconnect/common/hooks/useFile'
import {Attachment} from '@hconnect/common/types'
import {spawnWarningToast} from '@hm/fundamental'
import {CircularProgress, Box} from '@mui/material'
import React, {useEffect, useState} from 'react'

import {AttachmentHandler, imageFluidSx} from './AttachmentHandler'

export const AttachmentItem = <TId extends string | number = number>({
  attachment,
  setActiveAttachmentId,
  disableError
}: {
  attachment: Attachment<TId>
  setActiveAttachmentId: (id: TId) => void
  disableError?: boolean
}) => {
  const [source, setSource] = useState<string | null>(null)
  const fileUrl = attachment.previewUrl || attachment.url
  const {data, isFetching, error} = useFile(fileUrl, attachment.mediaType, attachment.id)

  useEffect(() => {
    if (data) {
      const blob = new Blob([data])
      const url = URL.createObjectURL(blob)
      setSource(url)
    } else if (error && !disableError) {
      spawnWarningToast(error.message)
    }
  }, [data, error, disableError])

  const {mediaType, id, fileName, url} = attachment

  const iconOrPreview = !!mediaType && mediaType.includes('image') ? 'preview' : 'icon'

  return (
    <span key={url} onClick={() => setActiveAttachmentId(id)}>
      {isFetching ? (
        <Box ml={2}>
          <CircularProgress />
        </Box>
      ) : (
        <AttachmentHandler
          key={id}
          file={source}
          alt={fileName}
          iconOrPreview={iconOrPreview}
          mediaType={mediaType}
          clickable={true}
          sx={imageFluidSx}
        />
      )}
    </span>
  )
}
